import { useContext, useEffect } from "react";
import AppContext from "../../../../appContext";

const PageLoading = ({
	actionMessage = "",
	states = [],
	disabled = false
}) => {
	const {
		showLoading,
		hideLoading
	} = useContext(AppContext);

	const activeState = states.find(state => state.loading);

	const loadingMessage = disabled
		? ""
		: actionMessage || activeState?.message || "";

	useEffect(() => {
		if (loadingMessage) {
			showLoading(loadingMessage);
		} else {
			hideLoading();
		}

		return () => {
			hideLoading();
		};
	}, [loadingMessage]);

	return null;
};

export default PageLoading;